import angular from 'angular';
import accountComponent from './account.component';
import accountService from './account.service';
import accountConfig from './account.config';

let accountModule = angular.module('app.account',[])
  .component('account', accountComponent)
  .service('AccountService', accountService)
  .config(accountConfig);

export default accountModule;



// WEBPACK FOOTER //
// ./www/components/account/account.js